import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { OAuthResponseModel } from 'src/app/shared/models/response/oauth-response.model';
import { environment } from 'src/environments/environment';
import { erroHandler } from '../erro-handler';

@Injectable({
  providedIn: 'root'
})
export class OAuthService {
  constructor(private http: HttpClient) {}

  getAccessToken(): Observable<OAuthResponseModel> {
    const body = {
      grant_type: 'client_credentials'
    };

    return this.http
      .post<OAuthResponseModel>(`${environment.oauth}`, body, {
        headers: {
          Authorization: `Basic ${environment.MceaKey}`,
          skip: 'true'
        }
      })
      .pipe(catchError(erroHandler));
  }
}
